<template>
  <label v-if="label" class="sidebar-list-label">{{ label }}</label>
  <ul class="sidebar-list">
    <slot />
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SidebarList',
  props: {
    label: String,
  },
});
</script>

<style lang="scss">
.sidebar-list-label {
  font-size: var(--font-size-12);
  font-family: var(--font-bold);
  color: var(--grey-ultra-dark);
  margin-left: var(--space-2);
  margin-bottom: var(--space-1);
  display: block;
}
.sidebar-list {
  border: 1px solid var(--grey-light);
  border-radius: 4px;
  overflow: auto;
}
</style>
